import config from '../config';
import {
  customFetch,
  authHeader,
  jsonHeader,
  handleResponse,
  commonRequestOptions,
  subjects,
} from '../helpers';

const endpointPath = config.api.API_URL + '/user';

export const userService = {
  getAll,
  getById,
  getFromAD,
  getPhotos,
  getOwnedItemsTotalCount,
  getOwnedItemsCount,
  getOwnedItems,
  getByPasswordResetToken,
  create,
  update,
  updateProfile,
  changePassword,
  forgotPassword,
  resetPassword,
  checkDestroy,
  destroy,
};

function getAll(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function getById(id, updateCurrentUser = false, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/${id}`, requestOptions, signal)
    .then(handleResponse)
    .then(res => {
      if (updateCurrentUser) {
        subjects.currentUser.next(res.users[0] || { user_id: id });
      }
      return res;
    });
}

function getPhotos(userIds, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify({ userIds: userIds }),
  };

  return customFetch(`${endpointPath}/photos`, requestOptions, signal).then(handleResponse);
}

function getFromAD(search, access_token, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify({ access_token: access_token }),
  };

  return customFetch(
    `${endpointPath}/search_ad/${encodeURIComponent(search)}`,
    requestOptions,
    signal,
    true,
    true
  ).then(handleResponse);
}

function getOwnedItemsTotalCount(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/owned_items_total_count`, requestOptions, signal).then(
    handleResponse
  );
}

function getOwnedItemsCount(userId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/owned_items_count/${userId}`, requestOptions, signal).then(
    handleResponse
  );
}

function getOwnedItems(userId, objectName, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/owned_items/${userId}/${objectName}`,
    requestOptions,
    signal
  ).then(handleResponse);
}

function getByPasswordResetToken(token, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(token),
  };

  return customFetch(`${endpointPath}/password_reset_token`, requestOptions, signal).then(
    handleResponse
  );
}

function create(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function update(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function updateProfile(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/update_profile`, requestOptions, signal).then(handleResponse);
}

function changePassword(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/change_password`, requestOptions, signal).then(
    handleResponse
  );
}

function forgotPassword(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/forgot_password`, requestOptions, signal).then(
    handleResponse
  );
}

function resetPassword(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/reset_password`, requestOptions, signal).then(handleResponse);
}

function checkDestroy(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/check_delete`, requestOptions, signal).then(handleResponse);
}

function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}
